import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { authContext } from './AuthenticationContext';
import { ItemResponse } from 'helpers/interfaces';
import { UserType } from 'helpers/enums';

interface IUser {
    email: string
    firstName: string
    lastName: string
    userType: UserType
    countryCode: string
    isSerialNumbersEditor: boolean
}

interface IApplicationUserContext {
    isLoading: boolean
    currentUser: IUser | undefined
}

export let appUserContext = React.createContext({} as IApplicationUserContext);

let { Provider } = appUserContext;

let ApplicationUserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let authService = useContext(authContext);

    let [isLoading, setLoading] = useState(true);
    let [currentUser, setCurrentUser] = useState<IUser>();


    useEffect(() => {
        if (authService.isLoading === false && authService.isAuthenticated === true)
            getCurrentUser();
    }, [authService.isLoading, authService.isAuthenticated])


    let getCurrentUser = async () => {
        try {
            setLoading(true);
            let res = await axios.get<ItemResponse<IUser>>('/api/AdminUser/GetCurrentUser');

            let { item } = res.data;

            setCurrentUser(item)

        } catch (err) {
        } finally {
            setLoading(false);
        }
    }


    return (
        <Provider
            value={{
                isLoading,
                currentUser,
            }}
        >
            {children}
        </Provider>
    )
}

export default ApplicationUserProvider;